"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReplaceVTOWorkflowContext = exports.ReplaceVTOWorkflowContextProvider = exports.ReplaceVTOWorkflowContext = void 0;
const react_1 = __importStar(require("react"));
exports.ReplaceVTOWorkflowContext = (0, react_1.createContext)({
    associateInfo: undefined,
    isChecked: undefined,
    isActionable: true,
    vTOSummaryInfoCase: undefined,
    vtoSummary: undefined,
    duration: undefined,
    showErrorFallback: false,
    isSubmitting: false,
    isSubmitDisabled: false,
    currentPTOBalance: undefined,
    updatedPTOBalance: undefined,
    setIsChecked: undefined,
    setVTOSummary: undefined,
    setIsActionable: undefined,
    setIsCurrentStepValid: undefined,
    setCurrentStepTitle: undefined,
    setShowErrorFallback: undefined,
    setDuration: undefined,
    setTotalSteps: undefined,
    setCurrentPTOBalance: undefined,
    setUpdatedPTOBalance: undefined,
    setVTOSummaryInfoCase: undefined,
    setIsSubmitDisabled: undefined
});
const ReplaceVTOWorkflowContextProvider = ({ replaceVTOWorkflowInitial, children }) => (react_1.default.createElement(exports.ReplaceVTOWorkflowContext.Provider, { value: Object.assign({}, replaceVTOWorkflowInitial) }, children));
exports.ReplaceVTOWorkflowContextProvider = ReplaceVTOWorkflowContextProvider;
const useReplaceVTOWorkflowContext = () => (0, react_1.useContext)(exports.ReplaceVTOWorkflowContext);
exports.useReplaceVTOWorkflowContext = useReplaceVTOWorkflowContext;
